// extracted by mini-css-extract-plugin
module.exports = {"lazyLog":"LazyLog_lazyLog__2CmSV","searchMatch":"LazyLog_searchMatch__laYsW"};